export default "__VITE_ASSET__6f39a18e__"